import React from "react";

/**
 * A label with an icon before it, for buttons and menu items.
 * @param {{icon: React.ReactNode, children: React.ReactNode}} props
 */
const IconLabel = ({icon, children}) => (
    <span className="d-inline-flex align-items-center">
        {icon}
        <span className="ms-2">{children}</span>
    </span>
);

export default IconLabel;
